import { useCallback, useEffect, useState } from 'react'

const COOLDOWN_SECONDS = 30

export function useCooldownTimer(seconds = COOLDOWN_SECONDS) {
  const [cooldownUntil, setCooldownUntil] = useState<number | null>(null)
  const [remainingSeconds, setRemainingSeconds] = useState(0)

  useEffect(() => {
    if (!cooldownUntil) {
      setRemainingSeconds(0)

      return
    }

    const tick = () => {
      const remaining = Math.max(0, Math.ceil((cooldownUntil - Date.now()) / 1000))

      setRemainingSeconds(remaining)

      if (remaining <= 0) {
        setCooldownUntil(null)
      }
    }

    tick()

    const interval = setInterval(tick, 1000)

    return () => clearInterval(interval)
  }, [cooldownUntil])

  const startCooldown = useCallback(() => {
    setCooldownUntil(Date.now() + seconds * 1000)
  }, [seconds])

  const clearCooldown = useCallback(() => {
    setCooldownUntil(null)
  }, [])

  return {
    remainingSeconds,
    isInCooldown: remainingSeconds > 0,
    startCooldown,
    clearCooldown,
  }
}
